function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M49.5 25c0 13.531-10.969 24.5-24.5 24.5S.5 38.531.5 25 11.469.5 25 .5 49.5 11.469 49.5 25z",
  fill: "#fff",
  stroke: "#3E3E3F"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.444 36.857c-.55 0-1.031-.18-1.443-.54a2.039 2.039 0 01-.715-1.333L15 14h20l-2.286 20.984c-.063.53-.285.974-.666 1.334-.381.36-.847.54-1.397.54H19.444zM17.16 22.095l1.397 12.699a.83.83 0 00.285.571c.17.148.37.222.603.222h11.207a.71.71 0 00.54-.238.927.927 0 00.253-.555l1.397-12.699H17.16zM17 20.825h16l.571-5.555H16.43L17 20.825zm8 12.381c.847 0 1.561-.29 2.143-.872a2.88 2.88 0 00.873-2.112c0-.677-.207-1.397-.62-2.159-.412-.761-1.21-1.904-2.396-3.428-1.185 1.524-1.984 2.667-2.396 3.428-.413.762-.62 1.482-.62 2.16 0 .825.29 1.529.872 2.111.583.582 1.297.872 2.144.872zm7.841-11.11H17.16 32.84zM25 31.935c-.487 0-.9-.169-1.238-.507a1.685 1.685 0 01-.508-1.238c0-.487.159-1.022.476-1.604.318-.582.74-1.232 1.27-1.952.53.762.952 1.423 1.27 1.983.317.562.476 1.086.476 1.573 0 .486-.17.899-.508 1.238a1.685 1.685 0 01-1.238.508z",
  fill: "#3E3E3F"
});

function SvgDrinkingWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "e71f2a866d8a6e02856969bcdbc9955a.svg";
export { SvgDrinkingWater as ReactComponent };